import React from 'react';
const images = [
// Green smoothie
'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=800&q=80',
// Avocado / keto bowl
'https://images.unsplash.com/photo-1543362906-acfc16c67564?w=800&q=80',
// Berries
'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=800&q=80',
// Salad
'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80',
// Steak / meat
'https://images.unsplash.com/photo-1558030006-450675393462?w=800&q=80',
// Fruit bowl
'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=800&q=80',
// Eggs / breakfast
'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=800&q=80',
// Smoothie bowl
'https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=800&q=80',
// Avocado halves
'https://images.unsplash.com/photo-1601039641847-7857b994d704?w=800&q=80'];
export function BackgroundCollage() {
  return <div aria-hidden="true" className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" data-id="element-8">
      {/* Image collage grid */}
      <div className="absolute inset-0 grid grid-cols-3 grid-rows-3 gap-0" data-id="element-9">
        {images.map((src, i) => <div key={i} className="w-full h-full bg-cover bg-center" style={{
        backgroundImage: `url(${src})`,
        filter: 'blur(40px) saturate(1.1)',
        transform: 'scale(1.2)'
      }} data-id="element-10" />)}
      </div>

      {/* Cream tint overlay — preserves the original warm aesthetic */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(180deg, rgba(245,241,232,0.88) 0%, rgba(245,241,232,0.92) 50%, rgba(245,241,232,0.9) 100%)'
    }} data-id="element-11" />

      {/* Subtle green tint for brand cohesion */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at top, rgba(34,197,94,0.08) 0%, transparent 60%)'
    }} data-id="element-12" />
    </div>;
}